import PropTypes from 'prop-types';

const vmPathPropType = PropTypes.arrayOf(
  PropTypes.oneOfType([PropTypes.string, PropTypes.number])
);

export default vmPathPropType;
